import { useEffect, useState } from 'react'
import { apiRequest, API_ENDPOINTS } from '../utils/api'

// Live FiveM status ({ online, clients, maxClients }) - polled while mounted.
// Shared by the home hero and the footer so both always agree.
export function useServerStatus(intervalMs = 60000) {
  const [status, setStatus] = useState(null)
  useEffect(() => {
    let cancelled = false
    const load = () =>
      apiRequest(API_ENDPOINTS.SERVER_PLAYERS, { method: 'GET' })
        .then((r) => r.json())
        .then((d) => { if (!cancelled) setStatus(d) })
        .catch(() => { if (!cancelled) setStatus({ online: false, clients: 0, maxClients: 0 }) })
    load()
    const id = setInterval(load, intervalMs)
    return () => { cancelled = true; clearInterval(id) }
  }, [intervalMs])
  return status
}

// Real Discord member count. (The API's uptime / daily-player numbers are
// hard-coded placeholders, so the redesign deliberately doesn't show them.)
export function useDiscordMembers() {
  const [members, setMembers] = useState(null)
  useEffect(() => {
    let cancelled = false
    apiRequest(API_ENDPOINTS.SERVER_STATS, { method: 'GET' })
      .then((r) => r.json())
      .then((d) => { if (!cancelled && d && d.discordMembers) setMembers(d.discordMembers) })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])
  return members
}
